module.exports = __webpack_public_path__ + "img/NodeJs.d57e27b3.jpg";